<template>
  <div style="padding: 20px">
    <Banner v-if="invites" :count="invites" />
    <vs-row>
      <div class="vx-col w-full" style="padding: 1rem">
        <h1 class="mb-6">Dashboard</h1>
        <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5">
          Welcome to the Ballstar Family!
        </p>
        <div>
          <vs-button @click="showScoreLeague = true">Score My League</vs-button>
        </div>
      </div>
      <vs-divider>Leagues & Teams</vs-divider>
      <div class="vx-col w-full text-center">
        These are the Leagues and Teams you have admin rights to
      </div>
      <div class="vx-col w-full lg:w-1/2 mb-base" style="padding: 1rem">
        <vx-card slot="no-body" class="text-center greet-user">
          <h1>
            <router-link :to="{ name: 'league-listing' }">
              {{ leagues }}
            </router-link>
          </h1>
          <h2>
            <router-link :to="{ name: 'league-listing' }">Leagues</router-link>
          </h2>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto">
            You have access to {{ leagues }} leagues.
          </p>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/2 mb-base" style="padding: 1rem">
        <vx-card slot="no-body" class="text-center greet-user">
          <h1>
            <router-link :to="{ name: 'team-season-listing' }">
              {{ teams }}
            </router-link>
          </h1>
          <h2>
            <router-link :to="{ name: 'team-season-listing' }"
              >Teams</router-link
            >
          </h2>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto">
            You have access to {{ teams }} teams.
          </p>
        </vx-card>
      </div>
    </vs-row>
    <vs-popup
      title="Score My League"
      :active.sync="showScoreLeague"
      background-color-popup="#FFF"
    >
      <ScoreMyLeague @scoreMyLeague="scoreMyLeagueRequest" />
    </vs-popup>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import UserRoles from "@/mixins/UserRoles";
import Banner from "@/components/banner/Banner";
import ScoreMyLeague from "@/views/pages/users/ScoreMyLeague";
export default {
  name: "profile",
  mixins: [UserRoles],
  components: {
    Banner,
    ScoreMyLeague
  },
  data: () => ({
    showScoreLeague: false
  }),
  computed: {
    invites() {
      return this.user && this.user.invites.length;
    },
    teams() {
      return this.user.teams && this.user.teams && this.user.teams.length;
    },
    leagues() {
      return this.user && this.user.leagues && this.user.leagues.length;
    }
  },
  methods: {
    ...mapActions({
      getProfile: "session/profile",
      scoreMyLeague: "league/scoreMyLeague"
    }),
    scoreMyLeagueRequest(data) {
      this.scoreMyLeague({ data });
      this.showScoreLeague = false;
      this.$toasted
        .success("We successfully received your request!")
        .goAway(2000);
    }
  },
  mounted() {
    this.getProfile();
  },
  metaInfo() {
    return { title: this.$route.meta.title };
  }
};
</script>
